import React, { useEffect, useMemo, useState } from 'react';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import Cookies from 'js-cookie';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import {
  handleCheckAccomodationDelete,
  deleteAccomodation,
  downloadAccomodationTemplate,
  uploadAccomodationTemplate,
  getUnitsByProjectId
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Modal from '../../shared/components/ui/Modal';
import mixpanel from 'mixpanel-browser';
import Button from '../../shared/components/ui/Button';
import Loader from '../../shared/components/ui/Loader';
import {
  Plus,
  ChevronDown,
  Download,
  Upload,
  Building2,
  Link2,
  Ruler,
  FileWarning,
  LayoutGrid,
  List
} from 'lucide-react';
import MetricCard from '../components/ui/MetricCard';
import AccommodationCard, { AddAccommodationCard } from '../components/ui/AccommodationCard';
import editIcon from '../../shared/assets/svg/edit.svg';
import deleteIcon from '../../shared/assets/svg/delete.svg';
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';

const AccommodationDetails = ({
  accommodations,
  isTableLoading = false,
  isTableRefreshing = false,
  isTableError = false,
  tableErrorMessage = 'Failed to load accommodations.',
  onEdit,
  refresh,
  handleToggleCreateNewModal
}) => {
  const userId = Cookies.get('userId');
  const [selectedType, setSelectedType] = useState('INDEPENDENT');
  const [tableHeight, setTableHeight] = useState('auto');
  const [canDelete, setCanDelete] = useState(null);
  const { id: projectId } = useParams();
  const rawMeasurementUnit = Cookies.get('measurement_type');
  const [resData, setResData] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const accommodationHeaderRef = React.useRef(null);
  const [accommodationDropdownRect, setAccommodationDropdownRect] = useState(null);
  const [isUploadTemplateModalOpen, setIsUploadTemplateModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploadErrorModalOpen, setIsUploadErrorModalOpen] = useState(false);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [plotAreaUnit, setPlotAreaUnit] = useState(
    rawMeasurementUnit === 'sq/ft' || rawMeasurementUnit === 'sq/mt' ? rawMeasurementUnit : 'sq/ft'
  );
  const [viewMode, setViewMode] = useState('card');

  const measurementUnit =
    !rawMeasurementUnit || rawMeasurementUnit === 'null' || rawMeasurementUnit === 'undefined'
      ? 'sq/ft'
      : rawMeasurementUnit;

  const accommodationTypes = {
    ALL: {
      title: 'All',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        'Linked Units',
        `Plot Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'CAD File',
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'linkedUnits',
        'plotArea',
        'buildUpArea',
        'carpetArea',
        'cadFileLink',
        'actions'
      ]
    },
    INDEPENDENT: {
      title: 'Independent',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        'Linked Units',
        `Plot Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'CAD File',
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'linkedUnits',
        'plotArea',
        'buildUpArea',
        'carpetArea',
        'cadFileLink',
        'actions'
      ]
    },
    GROUP: {
      title: 'Group',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        'Linked Units',
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'CAD File',
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'linkedUnits',
        'buildUpArea',
        'carpetArea',
        'cadFileLink',
        'actions'
      ]
    },
    PARKING: {
      title: 'Parking',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        'Linked Units',
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'Electrified',
        'CAD File',
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'linkedUnits',
        'buildUpArea',
        'electrified',
        'cadFileLink',
        'actions'
      ]
    }
  };

  const { data: projectUnits } = useQuery({
    queryKey: ['unitsByProject', projectId],
    queryFn: () => getUnitsByProjectId(projectId),
    enabled: !!projectId
  });

  const accommodationMetrics = useMemo(() => {
    const list = accommodations || [];

    const parseBuildup = (item) => {
      const raw = item?.buildUpArea;
      if (raw === null || raw === undefined || raw === '') return null;
      const n = parseFloat(String(raw).replace(/,/g, ''));
      return Number.isFinite(n) ? n : null;
    };

    const buildupVals = list.map(parseBuildup).filter((v) => v !== null);
    const avgBuildup =
      buildupVals.length > 0 ? buildupVals.reduce((a, b) => a + b, 0) / buildupVals.length : null;

    const cadMissing = list.filter((item) => {
      const links = item?.cadFileLink;
      return !Array.isArray(links) || links.length === 0;
    }).length;

    return {
      total: list.length,
      avgBuildup,
      cadMissing
    };
  }, [accommodations]);

  const linkedUnitsCount = useMemo(() => {
    if (!projectUnits?.length) return 0;
    return projectUnits.filter((u) => {
      const aid = u?.accomodation_id ?? u?.accommodation_id ?? u?.accommodation?.id;
      return aid != null && aid !== '';
    }).length;
  }, [projectUnits]);

  const linkedUnitsByAccommodationId = useMemo(() => {
    const map = new Map();
    if (!projectUnits?.length) return map;
    for (const u of projectUnits) {
      const aid = u?.accomodation_id ?? u?.accommodation_id ?? u?.accommodation?.id;
      if (aid == null || aid === '') continue;
      const key = Number(aid);
      if (Number.isNaN(key)) continue;
      map.set(key, (map.get(key) || 0) + 1);
    }
    return map;
  }, [projectUnits]);

  const getData = (type) => {
    // If type is 'ALL', don't filter - show all accommodations
    const filteredAccommodations =
      type === 'ALL'
        ? accommodations
        : accommodations?.filter((item) => item.accomodationType === type);

    return filteredAccommodations?.map((item) => {
      const accId = Number(item?.id);
      const linkedUnits = Number.isFinite(accId)
        ? linkedUnitsByAccommodationId.get(accId) ?? 0
        : 0;
      // Format numeric values preserving decimal places
      const formattedItem = {
        ...item,
        plotArea: item.plotArea?.toString() || '',
        buildUpArea: item.buildUpArea?.toString() || '',
        carpetArea: item.carpetArea?.toString() || '',
        linkedUnits
      };
      return transformData(formattedItem, accommodationTypes[type].form);
    });
  };
  const tableData = getData(selectedType) || [];
  const showTableLoading = !isTableError && (isTableLoading || typeof accommodations === 'undefined');
  const displayedAccommodationMetrics = isTableError
    ? { total: 0, avgBuildup: 0, cadMissing: 0 }
    : accommodationMetrics;
  const displayedLinkedUnitsCount = isTableError ? 0 : linkedUnitsCount;

  const calculateHeight = (data) => {
    // Let table grow naturally based on content
    if (data?.length == 0) {
      return '200px'; // Minimum height for empty state
    }
    return 'auto'; // Let it grow naturally
  };

  // 1. Accommodation List Viewed (on mount and when type changes)

  // Track page view
  useEffect(() => {
    mixpanel.track('Accommodation Details Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    const data = getData(selectedType);
    setTableHeight(calculateHeight(data));
    mixpanel.track('Accommodation List Viewed', { type: selectedType, count: data?.length || 0 });
  }, [selectedType, accommodations]);

  const handleTypeChange = (e) => {
    setSelectedType(e);

    mixpanel.track('Accommodation Type Changed', {
      user_id: userId,
      from_type: selectedType,
      to_type: e,
      timestamp: new Date().toISOString()
    });
  };

  // Conversion function for plot area
  const convertPlotArea = (value, fromUnit, toUnit) => {
    if (!value || value === '---') return value;

    const numValue = parseFloat(value);
    if (isNaN(numValue)) return value;

    // Normalize unit formats (handle variations like sqft, sq/ft, sq ft, etc.)
    const normalizeUnit = (unit) => {
      if (!unit) return 'sq/ft';
      const normalized = unit.toLowerCase().replace(/\s+/g, '');
      if (normalized === 'sqft' || normalized === 'sq/ft' || normalized === 'sqfeet')
        return 'sq/ft';
      if (normalized === 'sqmt' || normalized === 'sq/mt' || normalized === 'sqm') return 'sq/mt';
      if (normalized === 'guntha' || normalized === 'gunta') return 'guntha';
      if (normalized === 'cents' || normalized === 'cent') return 'cents';
      return unit;
    };

    const normalizedFromUnit = normalizeUnit(fromUnit);
    const normalizedToUnit = normalizeUnit(toUnit);

    // If same unit, return as is
    if (normalizedFromUnit === normalizedToUnit) return numValue.toFixed(2);

    // Conversion factors (how many sq/ft in 1 unit)
    const sqFtPerUnit = {
      'sq/ft': 1,
      'sq/mt': 10.764, // 1 sq/mt = 10.764 sq/ft
      guntha: 1089, // 1 guntha = 1089 sq/ft
      cents: 435.6 // 1 cent = 435.6 sq/ft
    };

    // Convert: value in fromUnit → sq/ft → toUnit
    const valueInSqFt = numValue * sqFtPerUnit[normalizedFromUnit];
    const convertedValue = valueInSqFt / sqFtPerUnit[normalizedToUnit];

    return convertedValue.toFixed(2);
  };

  // Handle plot area unit selection
  const handlePlotAreaUnitChange = (unit) => {
    setPlotAreaUnit(unit);

    mixpanel.track('Plot Area Unit Changed', {
      user_id: userId,
      from_unit: plotAreaUnit,
      to_unit: unit,
      timestamp: new Date().toISOString()
    });
  };

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckAccomodationDelete(id),
    onMutate: (id) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Check Accommodation Delete Started', {
        user_id: userId,
        accommodation_id: id,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, id) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        console.error('Error checking dependencies', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error checking dependencies'
        );

        mixpanel.track('Check Accommodation Delete Failed', {
          user_id: userId,
          accommodation_id: id,
          type: selectedType,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      const accommodationItem = getData(selectedType)?.find(
        (item) => parseInt(item.id) === parseInt(id)
      );
      const AccommodationsName = accommodationItem?.name || 'accommodation';

      if (result.canDelete) {
        setCanDelete('yes');
        setResData({ name: AccommodationsName });
        setSelectedIds([parseInt(id)]);

        mixpanel.track('Accommodation Delete Allowed', {
          user_id: userId,
          accommodation_id: id,
          accommodation_name: AccommodationsName,
          type: selectedType,
          timestamp: new Date().toISOString()
        });
      } else {
        setResData({ ...result, name: AccommodationsName });
        setCanDelete('no');

        mixpanel.track('Accommodation Delete Blocked', {
          user_id: userId,
          accommodation_id: id,
          accommodation_name: AccommodationsName,
          type: selectedType,
          reasons: result.reason,
          timestamp: new Date().toISOString()
        });
      }
    },
    onError: (err, id) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');

      mixpanel.track('Check Accommodation Delete Failed', {
        user_id: userId,
        accommodation_id: id,
        type: selectedType,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteAccomodation(payload),
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Delete Accommodation Started', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        console.error('Error deleting accommodation', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error deleting accommodation'
        );

        mixpanel.track('Delete Accommodation Failed', {
          user_id: userId,
          accommodation_ids: variables?.ids,
          type: selectedType,
          is_bulk: variables?.ids?.length > 1,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      toast.success('Accommodations Deleted Successfully');
      refresh?.();

      mixpanel.track('Delete Accommodation Success', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error deleting accommodation', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting accommodation');

      mixpanel.track('Delete Accommodation Failed', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  // Accommodation Edit Clicked
  const handleEdit = (id) => {
    mixpanel.track('Accommodation Edit Clicked', {
      user_id: userId,
      accommodation_id: id,
      type: selectedType,
      timestamp: new Date().toISOString()
    });
    onEdit(id);
  };

  // PortalDropdown component
  const PortalDropdown = ({ anchorRect, children, onClose }) => {
    if (!anchorRect) return null;
    const dropdownRef = React.useRef(null);

    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          onClose && onClose();
        }
      };
      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          onClose && onClose();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscape);
      };
    }, [onClose]);
    return createPortal(
      <div
        ref={dropdownRef}
        className="absolute bg-white border rounded shadow z-[1000]"
        style={{
          position: 'fixed',
          left: anchorRect.left,
          top: anchorRect.bottom,
          minWidth: anchorRect.width,
          maxHeight: '250px',
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>,
      document.body
    );
  };

  // Handler to open dropdown and set position
  const handleHeaderDropdownClick = (type, event) => {
    // If clicking the same dropdown that's already open, close it
    if (openDropdown === type) {
      setOpenDropdown(null);
      return;
    }

    if (type === 'accommodation' && accommodationHeaderRef?.current) {
      setAccommodationDropdownRect(accommodationHeaderRef?.current?.getBoundingClientRect());
    }
    setOpenDropdown(type);
  };

  // Handler to close dropdown
  const handleCloseDropdown = () => setOpenDropdown(null);

  // Handler to select type
  const handleSelectDropdownItem = (type) => {
    setOpenDropdown(null);
    handleTypeChange(type);
  };

  // Download template mutation
  const { mutate: handleDownloadAccommodationTemplate } = useMutation({
    mutationFn: () => downloadAccomodationTemplate(projectId),
    onMutate: () => {
      setIsSubmitting(true);
      mixpanel.track('Download Accommodation Template Started', {
        user_id: userId,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: (data) => {
      setIsSubmitting(false);
      if (!data || data.size === 0) {
        toast.error('Error: File data is empty or invalid.');
        return;
      }

      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Accommodation_Template.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('Accommodation Template Downloaded');

      mixpanel.track('Download Accommodation Template Success', {
        user_id: userId,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      setIsSubmitting(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Error in downloading Accommodation Template'
      );
      mixpanel.track('Download Accommodation Template Failed', {
        user_id: userId,
        type: selectedType,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Handler for file selection in upload modal
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  // Handler for download template button
  const handleDownloadTemplateClick = () => {
    handleDownloadAccommodationTemplate();
  };

  // Handler for upload template button
  const handleUploadTemplateClick = () => {
    setIsUploadTemplateModalOpen(true);
  };

  // Handler for upload template submission
  const handleUploadTemplateSubmit = async () => {
    if (!selectedFile) {
      toast.error('Please select a file');
      return;
    }

    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('file', selectedFile);

      formData.append('project_id', projectId);

      const response = await uploadAccomodationTemplate(formData);
      console.log('Uploaded template', response);

      // Check if there are errors in the response
      if (response?.data?.errors && response.data.errors.length > 0) {
        // Show error modal with validation errors
        setUploadErrors(response.data.errors);
        setIsUploadErrorModalOpen(true);
        setIsUploadTemplateModalOpen(false);
      } else {
        // No errors, proceed with success flow
        toast.success('Accommodation Template uploaded successfully');
        refresh?.();
        setIsUploadTemplateModalOpen(false);
        setSelectedFile(null);

        mixpanel.track('Upload Accommodation Template Success', {
          user_id: userId,
          type: selectedType,
          timestamp: new Date().toISOString()
        });
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to upload Accommodation Template'
      );
      mixpanel.track('Upload Accommodation Template Failed', {
        user_id: userId,
        type: selectedType,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full flex flex-col px-5 bg-gray-100 overflow-hidden">
      <Loader isVisible={isSubmitting} />
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this accommodation'}'`}
          onClose={() => {
            setCanDelete(null);
            mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this accomodation has dependencies, please delete following units to
              proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
            mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'accommodation'}
            onClose={() => {
              setCanDelete(null);
              setSelectedIds([]);
              mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
            }}
            data={getData(selectedType)}
            type={'accommodation'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Upload Template Modal */}
      {isUploadTemplateModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Upload Accommodation Template"
          onClose={() => {
            setIsUploadTemplateModalOpen(false);
            setSelectedFile(null);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select File</label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileSelect}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {selectedFile && (
                  <p className="text-sm text-gray-600 mt-1">Selected: {selectedFile.name}</p>
                )}
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadTemplateModalOpen(false);
                    setSelectedFile(null);
                  }}
                  displayType="secondary">
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={handleUploadTemplateSubmit}
                  disabled={!selectedFile || isSubmitting}>
                  {isSubmitting ? 'Uploading...' : 'Upload Template'}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Upload Error Modal */}
      {isUploadErrorModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Upload Validation Errors"
          onClose={() => {
            setIsUploadErrorModalOpen(false);
            setUploadErrors([]);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-sm text-red-800 mb-3">
                  The following errors were found in your uploaded file. Please fix these issues and
                  try uploading again:
                </p>
                <ul className="space-y-2">
                  {uploadErrors.map((error, index) => (
                    <li key={index} className="text-sm text-red-700 flex items-start">
                      <span className="text-red-500 mr-2">•</span>
                      <span>{error}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadErrorModalOpen(false);
                    setUploadErrors([]);
                  }}
                  displayType="secondary">
                  Close
                </Button>
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadErrorModalOpen(false);
                    setUploadErrors([]);
                    // Reopen upload modal for retry
                    setIsUploadTemplateModalOpen(true);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white">
                  Try Again
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4 sm:gap-4 w-full shrink-0">
        <MetricCard
          title="Total Accommodation"
          value={displayedAccommodationMetrics.total || 0}
          icon={<Building2 size={20} />}
          iconBgClass="bg-indigo-100"
          iconColorClass="text-indigo-600"
          valueColorClass="text-indigo-700"
          borderClass="border-indigo-200"
        />
        <MetricCard
          title="Linked Units"
          value={displayedLinkedUnitsCount}
          icon={<Link2 size={20} />}
          iconBgClass="bg-teal-100"
          iconColorClass="text-teal-700"
          valueColorClass="text-teal-800"
          borderClass="border-teal-200"
        />
        <MetricCard
          title="Avg Buildup Area"
          icon={<Ruler size={20} />}
          iconBgClass="bg-violet-100"
          iconColorClass="text-violet-700"
          valueColorClass="text-violet-900"
          borderClass="border-violet-200"
          displayValue={
            displayedAccommodationMetrics.avgBuildup != null ? (
              <>
                {displayedAccommodationMetrics.avgBuildup.toLocaleString('en-IN', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 0
                })}{' '}
                <span className="text-lg font-semibold text-violet-700">{measurementUnit}</span>
              </>
            ) : (
              <span className="text-xl font-semibold text-gray-400">—</span>
            )
          }
        />
        <MetricCard
          title="CAD File Missing"
          value={displayedAccommodationMetrics.cadMissing || 0}
          icon={<FileWarning size={20} />}
          iconBgClass="bg-amber-100"
          iconColorClass="text-amber-700"
          valueColorClass="text-amber-900"
          borderClass="border-amber-200"
        />
      </div>

      {/* Floating + button section commented out as requested. */}
      {/*
      <div
        className="fixed bottom-8 right-8 z-50"
        onMouseEnter={() => {
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            setHoverTimeout(null);
          }
          setIsExpanded(true);
        }}
        onMouseLeave={() => {
          const timeout = setTimeout(() => {
            setIsExpanded(false);
          }, 200);
          setHoverTimeout(timeout);
        }}>
        <div className="relative">
          {isExpanded && (
            <div
              className="absolute bottom-16 right-0 flex flex-col gap-3 pointer-events-auto items-end"
              onMouseEnter={() => {
                if (hoverTimeout) {
                  clearTimeout(hoverTimeout);
                  setHoverTimeout(null);
                }
              }}
              onMouseLeave={() => {
                const timeout = setTimeout(() => {
                  setIsExpanded(false);
                }, 200);
                setHoverTimeout(timeout);
              }}>
              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Download Template (Irregular)
                </span>
                <button
                  onClick={handleDownloadTemplateClick}
                  disabled={isSubmitting}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-500 hover:bg-blue-600 transition-colors duration-200 shadow-lg border-0">
                  <Download size={16} className="text-white" />
                </button>
              </div>

              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Upload Template (Irregular)
                </span>
                <button
                  onClick={handleUploadTemplateClick}
                  disabled={isSubmitting}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-green-500 hover:bg-green-600 transition-colors duration-200 shadow-lg border-0">
                  <Upload size={16} className="text-white" />
                </button>
              </div>
            </div>
          )}

          <Button
            displayType="primary"
            onClick={() => {
              mixpanel.track('Create New Accommodation Button Clicked', {
                user_id: userId,
                type: selectedType,
                timestamp: new Date().toISOString()
              });
              handleToggleCreateNewModal();
            }}
            customStyle={{
              borderRadius: '50%',
              width: '56px',
              height: '56px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              position: 'relative',
              zIndex: 10
            }}>
            <Plus size={24} color="white" />
          </Button>
        </div>
      </div>
      */}

      <div className="mt-7">
        {/* Unit Selector Above Table */}
        <div className="mb-4 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-gray-700">Area Unit:</span>
            <select
              value={plotAreaUnit}
              onChange={(e) => handlePlotAreaUnitChange(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none bg-white text-gray-900 cursor-pointer">
              <option value="sq/ft">sq/ft</option>
              <option value="sq/mt">sq/mt</option>
              <option value="guntha">guntha</option>
              <option value="cents">cents</option>
            </select>

            <div className="flex items-center gap-2" ref={accommodationHeaderRef}>
              <span className="text-sm font-medium text-gray-700">Type:</span>
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
                onClick={(e) => {
                  e.stopPropagation();
                  handleHeaderDropdownClick('accommodation', e);
                }}>
                {selectedType === 'ALL'
                  ? 'All'
                  : selectedType === 'INDEPENDENT'
                    ? 'Independent'
                    : selectedType === 'GROUP'
                      ? 'Group'
                      : 'Parking'}
                <ChevronDown size={16} className="text-gray-600" />
              </button>
              {openDropdown === 'accommodation' && accommodationDropdownRect && (
                <PortalDropdown anchorRect={accommodationDropdownRect} onClose={handleCloseDropdown}>
                  {[
                    { id: 'INDEPENDENT', label: 'Independent' },
                    { id: 'GROUP', label: 'Group' },
                    { id: 'PARKING', label: 'Parking' }
                  ].map((type) => (
                    <div
                      key={type.id}
                      className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                        type.id === selectedType && 'bg-blue-100'
                      }`}
                      onClick={() => handleSelectDropdownItem(type.id)}>
                      {type.label}
                    </div>
                  ))}
                </PortalDropdown>
              )}
            </div>

            <div className="inline-flex items-center rounded-xl border border-[#DCE3EA] bg-white p-1 shadow-sm shrink-0">
              <button
                type="button"
                onClick={() => setViewMode('card')}
                className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                  viewMode === 'card'
                    ? 'bg-[#EEF2F5] text-[#617087]'
                    : 'text-[#7A879B] hover:text-[#617087]'
                }`}
                aria-label="Card view">
                <LayoutGrid size={14} />
                <span>Card View</span>
              </button>
              <button
                type="button"
                onClick={() => setViewMode('table')}
                className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                  viewMode === 'table'
                    ? 'bg-[#EEF2F5] text-[#0F4D52]'
                    : 'text-[#7A879B] hover:text-[#617087]'
                }`}
                aria-label="Table view">
                <List size={14} />
                <span>Table View</span>
              </button>
            </div>

            {isTableRefreshing && (
              <span className="inline-flex items-center gap-2 rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                <span className="h-3 w-3 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600" />
                Refreshing...
              </span>
            )}
          </div>

          <div className="flex items-center gap-2">
            {/* <button
              type="button"
              onClick={() => {
                mixpanel.track('Create New Accommodation Button Clicked', {
                  user_id: userId,
                  type: selectedType,
                  timestamp: new Date().toISOString()
                });
                handleToggleCreateNewModal();
              }}
              className="inline-flex items-center gap-2 rounded-lg bg-[#2B5C66] px-4 py-2 text-white hover:bg-[#244F58] transition-colors">
              <Plus size={16} />
              Add Accommodation
            </button> */}
            <Button
              onClick={handleDownloadTemplateClick}
              disabled={isSubmitting}
              customStyle={{
                borderColor: '#2B5C66',
                color: '#2B5C66',
                backgroundColor: '#FFFFFF'
              }}
              displayType="secondary">
              <span className="inline-flex items-center gap-2 text-[#2B5C66]">
                <Download size={16} />
                {isSubmitting ? 'Downloading...' : 'Download'}
              </span>
            </Button>
            <button
              type="button"
              onClick={handleUploadTemplateClick}
              disabled={isSubmitting}
              className="inline-flex items-center gap-2 rounded-lg bg-[#2B5C66] px-4 py-2 text-white disabled:opacity-60 hover:bg-[#244F58] transition-colors">
              <Upload size={16} />
              {isSubmitting ? 'Uploading...' : 'Upload'}
            </button>
          </div>
        </div>

        <div className="accommodation-table-container">
          <style>{`
            .accommodation-table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .accommodation-table-container .table-container {
              height: auto !important;
            }
            .accommodation-table-container > div {
              height: auto !important;
            }
          `}</style>
          {viewMode === 'card' ? (
            <div className="pb-4">
              {isTableError ? (
                <div className="rounded-2xl border border-red-200 bg-white px-6 py-14 text-center">
                  <p className="text-sm font-medium text-red-600">{tableErrorMessage}</p>
                  <Button
                    title="Retry"
                    onClick={() => refresh?.()}
                    className="!mt-4 !px-4 !py-2 !text-sm !font-semibold"
                  />
                </div>
              ) : showTableLoading ? (
                <div className="rounded-2xl border border-gray-200 bg-white px-6 py-14 flex items-center justify-center gap-3 text-gray-600">
                  <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary" />
                  <span className="text-sm font-medium">Loading accommodations...</span>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <AddAccommodationCard
                    onAdd={() => {
                      mixpanel.track('Create New Accommodation Button Clicked', {
                        user_id: userId,
                        type: selectedType,
                        timestamp: new Date().toISOString()
                      });
                      handleToggleCreateNewModal();
                    }}
                  />
                  {tableData.map((item, index) => (
                    <AccommodationCard
                      key={item?.id ?? index}
                      item={item}
                      plotAreaUnit={plotAreaUnit}
                      measurementUnit={measurementUnit}
                      convertPlotArea={convertPlotArea}
                      onEdit={handleEdit}
                      onRequestDelete={handleCheckDelete}
                    />
                  ))}
                </div>
              )}
            </div>
          ) : (
          <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-21rem)] custom-scrollbar">
              <table className="w-full border-collapse text-left">
              <thead className="sticky top-0 z-20 bg-[#F8F9FA]">
                <tr className="w-full">
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Name
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Type
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Unit Type
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200 text-center tabular-nums">
                    Linked Units
                  </th>
                  {selectedType === 'INDEPENDENT' && (
                    <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                      Plot Area ({plotAreaUnit})
                    </th>
                  )}
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Build Up Area ({plotAreaUnit})
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Carpet Area ({plotAreaUnit})
                  </th>
                  {selectedType === 'PARKING' && (
                    <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                      Electrified
                    </th>
                  )}
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200">
                    CAD File
                  </th>
                  <th className="px-5 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200 text-center w-[120px]">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {isTableError ? (
                  <tr>
                    <td
                      colSpan={
                        selectedType === 'INDEPENDENT' ? 9 : selectedType === 'PARKING' ? 9 : 8
                      }
                      className="bg-white px-5 py-14 text-center align-middle">
                      <div className="flex flex-col items-center justify-center gap-3">
                        <p className="text-sm font-medium text-red-600">{tableErrorMessage}</p>
                        <Button
                          title="Retry"
                          onClick={() => refresh?.()}
                          className="!px-4 !py-2 !text-sm !font-semibold"
                        />
                      </div>
                    </td>
                  </tr>
                ) : showTableLoading ? (
                  <tr>
                    <td
                      colSpan={
                        selectedType === 'INDEPENDENT' ? 9 : selectedType === 'PARKING' ? 9 : 8
                      }
                      className="bg-white px-5 py-14 text-center align-middle">
                      <div className="flex items-center justify-center gap-3 text-gray-600">
                        <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary" />
                        <span className="text-sm font-medium">Loading accommodations...</span>
                      </div>
                    </td>
                  </tr>
                ) : tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr
                      key={item?.id || index}
                      className="border-0 bg-white transition-colors hover:bg-gray-50/90">
                      <td className="px-5 py-4 text-sm font-semibold text-gray-900">
                        {item?.name || '—'}
                      </td>
                      <td className="px-5 py-4 text-sm text-gray-600">
                        {String(item?.accomodationType || '').toUpperCase() === 'ALL'
                          ? '—'
                          : item?.accomodationType || '—'}
                      </td>
                      <td className="px-5 py-4 text-sm text-gray-600">{item?.unitType || '—'}</td>
                      <td className="px-5 py-4 text-sm text-gray-600 text-center tabular-nums">
                        {Number(item?.linkedUnits ?? 0).toLocaleString('en-IN')}
                      </td>
                      {selectedType === 'INDEPENDENT' && (
                        <td className="px-5 py-4 text-sm text-gray-600">
                          {item?.plotArea
                            ? convertPlotArea(
                                item.plotArea,
                                measurementUnit || 'sq/ft',
                                plotAreaUnit
                              )
                            : '—'}
                        </td>
                      )}
                      <td className="px-5 py-4 text-sm text-gray-600">
                        {item?.buildUpArea
                          ? convertPlotArea(
                              item.buildUpArea,
                              measurementUnit || 'sq/ft',
                              plotAreaUnit
                            )
                          : '—'}
                      </td>
                      <td className="px-5 py-4 text-sm text-gray-600">
                        {item?.carpetArea
                          ? convertPlotArea(
                              item.carpetArea,
                              measurementUnit || 'sq/ft',
                              plotAreaUnit
                            )
                          : '—'}
                      </td>
                      {selectedType === 'PARKING' && (
                        <td className="px-5 py-4 text-sm text-gray-600">{item?.electrified || '—'}</td>
                      )}
                      <td className="px-5 py-4 text-sm text-gray-600">
                        {item?.cadFileLink?.length > 0 ? (
                          <div className="flex flex-col gap-1.5">
                            {item.cadFileLink.map((file, idx) => (
                              <a
                                key={file?.id ?? idx}
                                href={file?.url}
                                download={file?.name}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 hover:underline text-sm truncate max-w-[200px]"
                                title={file?.name}>
                                <Download size={14} className="shrink-0 opacity-80" />
                                {file?.name || 'Download'}
                              </a>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                      <td className="px-5 py-4">
                        <div className="flex items-center justify-center gap-2">
                          <button
                            type="button"
                            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(item?.id);
                            }}
                            aria-label="Edit accommodation">
                            <img src={editIcon} alt="" className="h-6 w-6" />
                          </button>
                          <button
                            type="button"
                            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckDelete(item?.id);
                            }}
                            aria-label="Delete accommodation">
                            <img src={deleteIcon} alt="" className="h-6 w-6" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={
                        selectedType === 'INDEPENDENT' ? 9 : selectedType === 'PARKING' ? 9 : 8
                      }
                      className="bg-white px-5 py-14 text-center align-middle">
                      <div className="flex flex-col items-center justify-center w-full h-full">
                        <h2 className="text-lg font-bold text-gray-800 mb-1">No Data Found</h2>
                        <p className="text-gray-600 text-sm">
                          No accommodations found for {selectedType.toLowerCase()} type.
                          <br />
                          Proceed with adding new accommodation.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccommodationDetails;
